import React from 'react';

const Loading = () => {
    return (
        <div>
            <div className='flex justify-center items-center mt-44'>
                <button className="btn loading">loading</button>
            </div>
        </div>
    );
};

export default Loading;